export default "__VITE_ASSET__CAsq66Jj__"